<template>
  <RcDialog :model-value="true" :title="$t('company_select_title')" :width="mobile ? '100%' : DialogUtils.MEDIUM"
    :fullscreen="mobile" :hideFooter="true" @closeDialog="handleClose">
    <div>
      <p class="text-medium-emphasis mb-4">
        {{ $t('people_company_change_body') }}
      </p>

      <v-list lines="one">
        <v-list-item v-for="company in availableCompanies" :key="company.id()" :title="company.name()" :border="true"
          @click="selectCompany(company.id())">
          <template v-slot:append>
            <v-btn color="success" variant="flat" size="small" @click="selectCompany(company.id())">
              {{ $t('company_select_select_button') }}
            </v-btn>
          </template>
        </v-list-item>
      </v-list>
    </div>
  </RcDialog>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { useDisplay } from 'vuetify';

import RcDialog from '@/v3/components/library/dialog/RcDialog.vue';
import DialogUtils from '@/v3/utils/DialogUtils.js';

const emit = defineEmits(['closeDialog']);

const store = useStore();
const route = useRoute();
const router = useRouter();
const { mobile } = useDisplay();

const domain = computed(() => store.getters.domain);

const availableCompanies = computed(() => {
  if (!domain.value) return [];

  const user = domain.value.session().user();
  if (!user || user.isNew()) return [];

  const employees = user.employees();
  const companiesForUser = employees.companys().find();

  return companiesForUser.sortByName();
});

const selectCompany = (companyId) => {
  if (!domain.value) return;

  const company = domain.value.companys().findById(companyId);
  if (company.isNew()) {
    console.error("Selected company not found.");
    return;
  }

  const user = domain.value.session().user();
  const employee = user.employees().findByCompanyId(company.id());
  domain.value.session().with(company);
  domain.value.session().with(employee);
  domain.value.session().companyName = company.name();

  store.dispatch('AuthStorage_updateCompany', company);

  try {
    const cookieString = window.localStorage["readyChek"];
    if (cookieString) {
      const cookie = JSON.parse(cookieString);
      cookie['Company'] = company.id();
      window.localStorage["readyChek"] = JSON.stringify(cookie);
    }
  } catch (e) {
    console.error("Failed to update company in localStorage:", e);
  }

  // Stay on the page the user was on, under the new company. Every operator page reads
  // the company from :operatorId, so the URL must change before the reload: a push that
  // has not finished when reload() runs reloads the old URL, and the page then looks up
  // the new company's records under the old company's id. The query is dropped because it
  // can carry the old company's record ids.
  const target = route.params.operatorId
    ? { name: route.name, params: { ...route.params, operatorId: company.idEncoded() } }
    : { path: `/portal/v3/operator/${company.idEncoded()}/dashboard` };
  router.replace(target)
    .catch(err => console.error("Navigation error during company change:", err))
    .finally(() => window.location.reload());
};

const handleClose = () => {
  emit('closeDialog');
};
</script>
